import MatchSetup from './MatchSetup'

export default MatchSetup
